module.exports = __webpack_public_path__ + "img/R06_EXIT.e20280e1.svg";